var profileFactory = function ($resource) {
    var retriveContactApi = "/participant-web-services/rest/partialauth/profile/retriveProfileInfo";
    var retrieveUserNameForOneidApi =
        "/participant-web-services/rest/partialauth/profile/retrieveUserName";
    var updatePersonalContactApi =
        "/participant-web-services/rest/partialauth/profile/updatePersonalContact";
    var updateCredentialsApi =
        "/participant-web-services/rest/partialauth/profile/updateCredentials";
    var retrieveUsernameApi = "/participant-web-services/rest/partialauth/getUsername";
    var forceChangePasswordApi = "rest/partialauth/updateForceChangePassword";
    var retrieveAuthorizedDevicesApi = "/participant-web-services/rest/auth/authorizedDevices";
    var updateAuthorizedDevicesApi =
        "/participant-web-services/rest/auth/saveAuthorizedDeviceChanges";

    var username = "";
    var econsentEmail = "";
    var secondaryEmail = "";
    var sourcepage = "";

    var firstLineMailing = "";
    var scndLineMailing = "";
    var city = "";
    var state = "";
    var country = "";
    var zipcode = "";

    var eConsentDetails = {};

    var authorizedDevices = [];

    return {
        getSourcepage: function () {
            return sourcepage;
        },
        setSourcepage: function (page) {
            sourcepage = page;
        },

        getUsername: function () {
            return username;
        },
        setUsername: function (name) {
            username = name;
        },

        getEconsentEmail: function () {
            return econsentEmail;
        },
        setEconsentEmail: function (myeconsentEmail) {
            econsentEmail = myeconsentEmail;
        },

        getSecondaryEmail: function () {
            return secondaryEmail;
        },
        setSecondaryEmail: function (mysecondaryEmail) {
            secondaryEmail = mysecondaryEmail;
        },

        getEConsentDetails: function () {
            return eConsentDetails;
        },
        setEConsentDetails: function (myeConsentDetails) {
            eConsentDetails = myeConsentDetails;
        },
        getFirstLineMailing: function () {
            return firstLineMailing;
        },
        setFirstLineMailing: function (myfirstLineMailing) {
            firstLineMailing = myfirstLineMailing;
        },
        getScndLineMailing: function () {
            return scndLineMailing;
        },
        setScndLineMailing: function (myscndLineMailing) {
            scndLineMailing = myscndLineMailing;
        },
        getCity: function () {
            return city;
        },
        setCity: function (mycity) {
            city = mycity;
        },
        getState: function () {
            return state;
        },
        setState: function (mystate) {
            state = mystate;
        },
        getCountry: function () {
            return country;
        },
        setCountry: function (mycountry) {
            country = mycountry;
        },
        getZipcode: function () {
            return zipcode;
        },
        setZipcode: function (myzipcode) {
            zipcode = myzipcode;
        },
        setAuthorizedDevices: function (devices) {
            authorizedDevices = devices;
        },
        getAuthorizedDevices: function () {
            return authorizedDevices;
        },

        retriveContactInfor: $resource(
            // eslint-disable-next-line no-undef
            __baseApiUrl__ + retriveContactApi,
            {},
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),

        updatePersonalContact: $resource(
            // eslint-disable-next-line no-undef
            __baseApiUrl__ + updatePersonalContactApi,
            {},
            {
                query: {
                    method: "POST",
                    isArray: false,
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            }
        ),

        updateCredentials: $resource(
            // eslint-disable-next-line no-undef
            __baseApiUrl__ + updateCredentialsApi,
            {},
            {
                query: {
                    method: "POST",
                    isArray: false,
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            }
        ),

        updateForceChangePassword: $resource(
            // eslint-disable-next-line no-undef
            __authenticationUrl__ + forceChangePasswordApi,
            {},
            {
                query: {
                    method: "POST",
                    isArray: false,
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            }
        ),

        retrieveUserNameForOneid: $resource(
            // eslint-disable-next-line no-undef
            __baseApiUrl__ + retrieveUserNameForOneidApi,
            {},
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),

        retrieveUsername: $resource(
            // eslint-disable-next-line no-undef
            __baseApiUrl__ + retrieveUsernameApi,
            {},
            {
                query: {
                    method: "GET"
                }
            }
        ),

        retrieveAuthorizedDevices: $resource(
            // eslint-disable-next-line no-undef
            __baseApiUrl__ + retrieveAuthorizedDevicesApi,
            {},
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),

        updateAuthorizedDevices: $resource(
            // eslint-disable-next-line no-undef
            __baseApiUrl__ + updateAuthorizedDevicesApi,
            {},
            {
                query: {
                    method: "POST",
                    isArray: false,
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            }
        )
    };
};

profileFactory.$inject = ["$resource"];
export default profileFactory;
